export default "__VITE_ASSET__$XpDjQtS__"